import { render } from "./SectionSideMenu.vue?vue&type=template&id=4835511b"
import script from "./SectionSideMenu.vue?vue&type=script&lang=js"
export * from "./SectionSideMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__